module.exports = __webpack_public_path__ + "img/coinbankB30.059e5b2f.jpg";